import React, { useState } from 'react';
import { Table, Input, Select, Pagination } from 'antd';
import {
    Search,
    Plus,
    Trash2,
    Edit,
    Copy,
    X,
    UserCheck,
    Menu
} from 'lucide-react';

import TreeItem from './UnitTree';
import Layout from '../../Layout';
import { useNavigate } from 'react-router-dom';

const WorkflowManagement = () => {
    const navigate = useNavigate();
    // State quản lý hiển thị sidebar trên mobile
    const [showMobileSidebar, setShowMobileSidebar] = useState(false);

    // Dữ liệu mẫu cho danh sách đơn vị bên trái
    const unitTreeData = [
        {
            id: 1,
            name: 'Tất cả',
            count: '1200 Quy trình',
            children: [
                {
                    id: 2,
                    name: 'Ban Tài Chính',
                    count: '300 Quy trình',
                    children: [
                        { id: 21, name: 'Phòng Ngân sách', count: '150 Quy trình' },
                        { id: 22, name: 'Phòng Kế toán tổng hợp', count: '150 Quy trình' },
                    ]
                },
                { id: 3, name: 'Ban Kế Toán', count: '200 Quy trình' },
                { id: 4, name: 'Ban Pháp Lý', count: '700 Quy trình' },
            ]
        }
    ];

    // Cột dữ liệu của Bảng (Ant Design Table)
    const columns = [
        {
            title: 'Hành động',
            key: 'actions',
            width: 100,
            render: () => (
                <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400">
                    <button title="Sửa" className="hover:text-blue-600 transition-colors"><Edit size={16} /></button>
                    <button title="Xóa" className="hover:text-red-600 transition-colors"><Trash2 size={16} /></button>
                    <button title="Sao chép" className="hover:text-blue-600 transition-colors"><Copy size={16} /></button>
                </div>
            ),
        },
        {
            title: 'Tên quy trình mẫu',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a className="text-blue-600 dark:text-blue-400 font-medium hover:underline">{text}</a>,
        },
        {
            title: 'Loại trình ký',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Đơn vị ban hành',
            dataIndex: 'department',
            key: 'department',
        },
        {
            title: 'Ngày hiệu lực',
            dataIndex: 'effectiveDate',
            key: 'effectiveDate',
        },
        {
            title: 'Tình trạng',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                const isValid = status === 'Còn hiệu lực';
                return (
                    <span className="flex items-center gap-1.5 whitespace-nowrap">
                        <span className={`w-2 h-2 rounded-full ${isValid ? 'bg-emerald-500' : 'bg-rose-500'}`} />
                        <span className={isValid ? 'text-emerald-700 dark:text-emerald-400 text-sm' : 'text-rose-700 dark:text-rose-400 text-sm'}>
                            {status}
                        </span>
                    </span>
                );
            },
        },
    ];

    // Dữ liệu mẫu cho bảng
    const dataSource = [
        { key: '1', name: 'Đơn xin nghỉ phép', type: '', department: 'Quản lý nhân sự', effectiveDate: '16/05/24', status: 'Còn hiệu lực' },
        { key: '2', name: 'Yêu cầu chuyển công tác', type: '', department: 'Quản lý nhân sự', effectiveDate: '16/05/24', status: 'Hết hiệu lực' },
        { key: '3', name: 'Đề xuất bổ nhiệm', type: '', department: 'Quản lý nhân sự', effectiveDate: '16/05/24', status: 'Còn hiệu lực' },
        { key: '4', name: 'Đề xuất tuyển dụng', type: 'Đánh giá nhân sự và t...', department: 'Chi nhánh TNHH', effectiveDate: '16/05/24', status: 'Hết hiệu lực' },
        { key: '5', name: 'Đề xuất bổ nhiệm', type: 'Đánh giá nhân sự và t...', department: 'Chi nhánh TNHH', effectiveDate: '16/05/24', status: 'Còn hiệu lực' },
    ];

    return (
        <Layout>
            <div className="flex flex-col min-h-[calc(100vh-64px)]">
                {/* --- HEADER --- */}
                <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 py-3 flex items-center justify-between rounded-xl">
                    <div className="flex items-center gap-2">
                        {/* Nút mở menu sidebar trên mobile */}
                        <button
                            onClick={() => setShowMobileSidebar(!showMobileSidebar)}
                            className="md:hidden p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-gray-600 dark:text-gray-300"
                        >
                            <Menu size={20} />
                        </button>
                        <div className="flex items-center gap-1.5 text-xs md:text-sm text-gray-500 dark:text-gray-400 truncate">
                            <span className="text-gray-900 dark:text-gray-100 font-medium truncate text-[18px]">Quản lý trình duyệt</span>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 md:gap-3">
                        <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-blue-600 dark:text-blue-400"><UserCheck size={20} /></button>
                        <button className="hidden sm:flex p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-blue-600 dark:text-blue-400"><Trash2 size={20} /></button>
                        <button className="hidden sm:flex p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-blue-600 dark:text-blue-400"><Edit size={20} /></button>
                        <button onClick={() => navigate('/submit-for-signature/add')} className="bg-blue-600 hover:bg-blue-700 text-white px-3 md:px-4 py-2 rounded-lg flex items-center gap-1.5 text-sm font-medium transition-colors shadow-sm whitespace-nowrap">
                            <Plus size={18} /> <span className="hidden sm:inline">Tạo mới</span>
                        </button>
                    </div>
                </header>

                {/* --- SUB-HEADER TITLE --- */}
                <div className="py-3 md:py-4 flex items-center gap-3">
                    <h1 className="text-lg md:text-xl font-bold text-gray-900 dark:text-gray-100">Trình ký</h1>
                    <span className="text-gray-500 dark:text-gray-400 text-xs md:text-sm">Tất cả (10)</span>
                </div>

                {/* --- MAIN CONTENT LAYOUT --- */}
                <div className="flex flex-1 pb-6 gap-6 relative overflow-hidden">

                    {/* --- SIDEBAR TRÁI (CÂY ĐƠN VỊ - Responsive Drawer cho Mobile) --- */}
                    <aside className={`
                        fixed md:relative inset-y-0 left-0 z-30 w-72 md:w-80 
                        bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 
                        rounded-xl p-4 flex flex-col gap-4 shadow-sm transition-transform duration-300
                        ${showMobileSidebar ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
                    `}>
                        <div className="flex items-center justify-between md:hidden pb-2 border-b border-gray-100 dark:border-gray-700">
                            <span className="font-semibold text-sm">Danh mục đơn vị</span>
                            <button onClick={() => setShowMobileSidebar(false)} className="p-1 text-gray-500 hover:text-gray-700">
                                <X size={18} />
                            </button>
                        </div>

                        <div className="relative">
                            <Input
                                placeholder="Tìm nhanh đơn vị"
                                suffix={<X size={16} className="text-gray-400 cursor-pointer hover:text-gray-600" />}
                                className="rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            />
                        </div>

                        {/* Khu vực hiển thị danh sách cây đa cấp */}
                        <div className="flex-1 overflow-y-auto space-y-1 pr-1">
                            {unitTreeData.map((rootItem) => (
                                <TreeItem key={rootItem.id} item={rootItem} level={0} />
                            ))}
                        </div>
                    </aside>

                    {/* Overlay nền mờ khi mở sidebar trên mobile */}
                    {showMobileSidebar && (
                        <div
                            onClick={() => setShowMobileSidebar(false)}
                            className="fixed inset-0 bg-black/50 z-20 md:hidden"
                        />
                    )}

                    {/* --- KHU VỰC BẢNG DỮ LIỆU PHẢI --- */}
                    <main className="flex-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-3 md:p-4 flex flex-col gap-4 shadow-sm overflow-hidden w-full">

                        {/* Bộ lọc / Tìm kiếm phía trên bảng */}
                        <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 justify-between">
                            <div className="flex items-center gap-3 flex-1 max-w-xl w-full">
                                <Input
                                    prefix={<Search size={16} className="text-gray-400 mr-2" />}
                                    placeholder="Tìm kiếm"
                                    className="rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                />
                            </div>

                            <div className="flex flex-wrap items-center gap-2 md:gap-3">
                                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500 dark:text-gray-400 flex-1 sm:flex-none">
                                    <span className="whitespace-nowrap">Loại trình ký</span>
                                    <Select
                                        defaultValue="all"
                                        className="w-full sm:w-40"
                                        options={[{ value: 'all', label: 'Chọn loại trình ký' }]}
                                    />
                                </div>

                                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500 dark:text-gray-400 flex-1 sm:flex-none">
                                    <span className="whitespace-nowrap">Tình trạng</span>
                                    <Select
                                        defaultValue="all"
                                        className="w-full sm:w-40"
                                        options={[{ value: 'all', label: 'Chọn tình trạng' }]}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Bảng Antd Table (Có cuộn ngang trên màn hình nhỏ) */}
                        <div className="flex-1 overflow-x-auto">
                            <Table
                                columns={columns}
                                dataSource={dataSource}
                                pagination={false}
                                className="dark-table"
                                rowClassName="dark:bg-gray-800 dark:hover:bg-gray-700/50"
                                scroll={{ x: 800 }}
                            />
                        </div>

                        {/* Phân trang bên dưới */}
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-2 border-t border-gray-100 dark:border-gray-700">
                            <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500 dark:text-gray-400">
                                <span>Số hàng mỗi trang</span>
                                <Select defaultValue="20" className="w-24" options={[{ value: '20', label: '20/ trang' }, { value: '10', label: '10/ trang' }]} />
                            </div>
                            <div className="flex items-center gap-4 text-xs md:text-sm text-gray-600 dark:text-gray-400">
                                <span className="hidden sm:inline">1-10 trong 85 dữ liệu</span>
                                <Pagination defaultCurrent={22} total={124} pageSize={10} simple className="dark:text-[#d1d5db]" />
                            </div>
                        </div>

                    </main>

                </div>
            </div>
        </Layout>
    );
};

export default WorkflowManagement;